export const COLUMNS = [
  {
    name: 'payPeriodId',
    label: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'payPeriodStartDate',
    label: 'Pay Period',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'careerCashin',
    label: 'Career Cash In',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'ytdCashinByEmployee',
    label: 'YTD Cash In',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'payPeriodCashin',
    label: 'Cash In',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'commissionTotal',
    label: 'Commission Total',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'drawBalanceTotal',
    label: 'Draw Balance',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  },
  {
    name: 'payableTotal',
    label: 'Payable Total',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'payPeriodStartDate',
  direction: 'asc'
};
